export const REPORT_MATCH_SORTER_KEYS = [
  { key: 'report.title', explanation: 'Titre du rapport' },
  { key: 'report.code', explanation: 'Code du rapport' },
] as const;
